/**
 * Get the full URL for a Strapi image
 * Handles both local uploads (/uploads/...) and S3 URLs (https://...)
 */
export function getStrapiImageUrl(url: string | undefined | null): string | null {
  if (!url) return null;

  // If URL is already absolute (starts with http:// or https://), return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }

  // Otherwise, it's a relative URL (local dev uploads) - prepend the CMS origin.
  // In production, Strapi media URLs are always absolute (S3), so this path is dev-only.
  return `http://localhost:1337${url}`;
}

/**
 * Returns true when Next.js image optimization should be skipped.
 * In local dev, Strapi serves uploads from localhost:1337 which the
 * Next.js image optimizer cannot reliably reach. In production the
 * images come from S3 (absolute https URLs) and optimization works fine.
 */
export function shouldUnoptimizeNextImage(url: string | null | undefined): boolean {
  return process.env.NODE_ENV !== 'production' && Boolean(url?.startsWith('http://localhost'));
}

